<div class="td-wb-top-navigation"
     role="navigation"
     aria-labelledby="td-wb-user-navigation-header">
  <h2 id="td-wb-user-navigation-header"
      class="td-wb-vh"
      translate="tdWb.menu.USER_HEADER"></h2>
  <ul class="td-wb-top-navigation__list"
      aria-labelledby="td-wb-user-navigation-header">
    <!-- Desktop  menu structure  - use overlay -->
    @for (item of navigationMenu().topNavigation; track item) {
      @if (item.id !== 'userMessages') {
        <li class="td-wb-top-navigation__list-item">
          <!--Generic with the exception of the padlock for logout-->
          @if (!item.menu && item.id !== 'userMessages' && item.id !== '4') {
            <a class="td-wb-top-navigation__link"
               [attr.target]="item.target"
               [href]="item.href"
               [innerHtml]="item.text"></a>
          }
          <!-- Logout -->
          @if (!item.menu && item.id !== 'userMessages' && item.id === '4') {
            <button *tdWbIfNoFeature="'wbrChatEnabled'"
                    class="td-wb-top-navigation__logout"
                    tdWbButton
                    tdWbButtonType="primary"
                    tdWbButtonSize="xs"
                    [tdWbHref]="item.href">
              <td-wb-icon iconId="lock"
                          size="14"/>
              <span [innerHtml]="item.text"></span>
            </button>
            <button *tdWbIfFeature="'wbrChatEnabled'"
                    class="td-wb-top-navigation__logout"
                    tdWbButton
                    tdWbButtonType="primary"
                    tdWbButtonSize="xs"
                    [tdWbHref]="item.href"
                    [tdWbHrefAsync]="true"
                    (onNavigate)="logout($event)">
              <td-wb-icon iconId="lock"
                          size="14"/>
              <span [innerHtml]="item.text"></span>
            </button>
          }
          <!-- Contact Us -->
          @if (item.menu && item.id !== 'user') {
            <td-wb-menu-item
              [menuItem]="item"
              [flyoutType]="flyoutType()">
              <td-wb-menu-item-toggle iconId="caret--down"
                                      size="12"
                                      [flyoutType]="flyoutType()"/>
              @if (item.open) {
                <td-wb-menu-item-content [flyoutType]="flyoutType()"
                                         class="td-wb-top-navigation--menu-item-content">
                  <div class="td-wb-top-navigation-item--contact-us"
                       [class.td-wb-top-navigation-item--contact-us-narrow]="item.menu.length < 4">
                    <div class="td-wb-nav__primary__content__col--getHelp">
                      @for (group of item.menu; track group) {
                        @if (group.id === 'getHelp' || group.id === 'visitUs') {
                          <ng-container [ngTemplateOutlet]="contactUsItemTemplate"
                                        [ngTemplateOutletContext]="{ group: group }"/>
                        }
                      }
                    </div>
                    @for (group of item.menu; track group) {
                      @if (group.id === 'contactUs') {
                        <ng-container [ngTemplateOutlet]="contactUsItemTemplate"
                                      [ngTemplateOutletContext]="{ group: group }"/>
                      }
                      @if (feedBackMenuItem !== undefined && group.id === 'weWantToHearFromYou') {
                        <div
                          class="td-wb-nav__primary__content__col td-wb-nav__primary__content__col--feedback">
                          <h2 class="td-wb-flyout-menu__item-header"
                              [innerHtml]="group.title"></h2>
                          <div class="td-wb-top-navigation__menu-feedback-content">
                            <span id="td-wb-aria-improve-feedback-header"
                                  class="td-wb-top-navigation__menu-feedback-text"
                                  translate="tdWb.menu.IMPROVE_EXPERIENCE">
                            </span>
                            <ul class="td-wb-ul td-wb-ul--basic td-wb-top-navigation__menu-feedback-content--list"
                                aria-labelledby="td-wb-aria-improve-feedback-header">
                              <li class="td-wb-top-navigation__menu-feedback-text">
                                <span translate="tdWb.menu.FEEDBACK_TOPIC_1"></span>
                              </li>
                              <li class="td-wb-top-navigation__menu-feedback-text">
                                <span translate="tdWb.menu.FEEDBACK_TOPIC_2"></span>
                              </li>
                              <li class="td-wb-top-navigation__menu-feedback-text">
                                <span translate="tdWb.menu.FEEDBACK_TOPIC_3"></span>
                              </li>
                            </ul>
                            <button class="td-wb-top-navigation__menu-feedback-link"
                                    tdWbButton
                                    tdWbButtonType="secondary"
                                    [tdWbHref]="feedBackMenuItem.href"
                                    target="_blank">
                              <span [translate]="feedBackMenuItem.text"></span>
                            </button>
                          </div>
                        </div>
                      }
                    }
                  </div>
                </td-wb-menu-item-content>
              }
            </td-wb-menu-item>
          }
          <!-- User -->
          @if (isTopMenuEnabled() && item.id === 'user') {
            <td-wb-top-navigation-item
              id="td-wb-aria-client-name-title"
              [flyoutMenuUserData]="flyoutMenuUserData">
              <td-wb-top-navigation-item-label>
                <span [class.td-wb-top-navigation--has-messages]="messageCounterSpacing"
                      class="td-wb-top-navigation__list-item-user-icon">
                  <td-wb-icon class="td-wb-top-navigation__message"
                              size="12"
                              iconId="avatar--small"
                              [inline]="true"/>
                  <td-wb-messages-counter class="td-wb-top-navigation__message-counter"/>
                </span>
                <span *tdWbIfNoFeature="'switchGiem'"
                      class="td-wb-top-navigation__list-item-user-title"
                      [innerText]="clientName()">
                </span>
                <span *tdWbIfFeature="'switchGiem'"
                      class="td-wb-top-navigation__list-item-user-title"
                      translate="tdWb.menu.SETTINGS_AND_SERVICES">
                </span>
              </td-wb-top-navigation-item-label>
              <td-wb-flyout-menu
                #flyoutMenuUserData="tdWbFlyoutMenu">
                <td-wb-flyout-menu-header *tdWbIfNoFeature="'switchGiem'">
                  <div class="td-wb-top-navigation__menu-header">
                    <span class="td-wb-top-navigation__menu-header-icon-container">
                      <td-wb-icon class="td-wb-top-navigation__menu-header-icon"
                                  iconId="avatar--small"
                                  size="19"/>
                    </span>
                    <span [innerHtml]="clientName()"></span>
                  </div>
                </td-wb-flyout-menu-header>
                <div class="td-wb-top-navigation__content"
                     aria-labelledby="td-wb-aria-client-name-title">
                  @if (profileMenuItem !== undefined) {
                    <a role="button"
                       [attr.target]="undefined"
                       id="td-wb-top-navigation__content__item-6"
                       tdWbHref="link_profile"
                       tdWbFlyoutMenuItem>
                      <span class="td-wb-top-navigation__menu-item">
                        <td-wb-icon iconId="avatar-outlined--small"
                                    size="20x20"/>
                        <span id="td-wb-top-navigation-profile-link"
                              class="td-wb-top-navigation__menu-item-text"
                              [innerText]="profileMenuItem.text"></span>
                      </span>
                    </a>
                  }
                  @if (customizeSiteMenuItem !== undefined) {
                    <a role="button"
                       [attr.target]="undefined"
                       id="td-wb-top-navigation__content__item-1"
                       [tdWbHref]="customizeSiteMenuItem.href"
                       tdWbHrefTaggingEvent="profile settings:customize site"
                       tdWbFlyoutMenuItem>
                      <span class="td-wb-top-navigation__menu-item">
                        <td-wb-icon iconId="cog-outline--small"
                                    size="20x20"/>
                        <span class="td-wb-top-navigation__menu-item-text"
                              [innerHtml]="customizeSiteMenuItem.text"></span>

                        @if (showNewBadge()) {
                          <td-wb-badge class="td-wb-top-navigation__menu-item-badge"
                                       [text]="'tdWb.menu.badge.NEW' | translate"
                                       size="extra-small"
                                       colour="accent"/>
                        }
                      </span>
                    </a>
                  }
                  @if (documentsMenuItem !== undefined) {
                    <a role="button"
                       [attr.target]="documentsMenuItem.target"
                       id="td-wb-top-navigation__content__item-3"
                       [href]="documentsMenuItem.href"
                       tdWbFlyoutMenuItem>
                      <span class="td-wb-top-navigation__menu-item">
                        <td-wb-icon iconId="copy--small"
                                    size="20x20"/>
                        <span class="td-wb-top-navigation__menu-item-text"
                              [innerHtml]="documentsMenuItem.text"></span>
                      </span>
                    </a>
                  }
                  @if ((messagesMenuItem !== undefined) && !secureMessageMenuItem) {
                    <a role="button"
                       [attr.target]="messagesMenuItem.target"
                       id="td-wb-top-navigation__content__item-5"
                       [href]="messagesMenuItem.href"
                       tdWbFlyoutMenuItem>
                      <span class="td-wb-top-navigation__menu-item">
                        <span class="td-wb-top-navigation__menu-item-envelope-icon">
                          <td-wb-icon size="20x20"
                                      iconId="email--small"
                                      [inline]="true"/>
                          <td-wb-messages-counter class="td-wb-top-navigation__message-counter"/>
                        </span>
                        <span class="td-wb-top-navigation__menu-item-text"
                              [innerHtml]="messagesMenuItem.text"></span>
                      </span>
                    </a>
                  }
                  @if (secureMessageMenuItem !== undefined) {
                    <a role="button"
                       [attr.target]="secureMessageMenuItem.target"
                       id="td-wb-top-navigation__content__item-6"
                       [href]="secureMessageMenuItem.href"
                       tdWbFlyoutMenuItem>
                      <span class="td-wb-top-navigation__menu-item">
                        <span class="td-wb-top-navigation__menu-item-envelope-icon">
                          <td-wb-icon size="20"
                                      iconId="email--small"/>
                          <td-wb-messages-counter class="td-wb-top-navigation__message-counter"/>
                        </span>
                        <span class="td-wb-top-navigation__menu-item-text"
                              [innerHtml]="secureMessageMenuItem.text"></span>
                      </span>
                    </a>
                  }
                </div>
              </td-wb-flyout-menu>
            </td-wb-top-navigation-item>
          }
        </li>
      }
    }

  </ul>
</div>

<ng-template #contactUsItemTemplate let-group="group">
  <div
    class="td-wb-nav__primary__content__col"
    [class.td-wb-nav__primary__content__col--help]="group.id === 'getHelp'"
    [class.td-wb-nav__primary__content__col--visit]="group.id === 'visitUs'"
    [class.td-wb-nav__primary__content__col--contact]="group.id === 'contactUs'">
    <h2 class="td-wb-flyout-menu__item-header"
        [innerHtml]="group.title"></h2>
    <div class="td-wb-flyout-menu__item-header-content">
      @for (link of group.item; track link) {
        @if (link.id === 'chat-with-live-agent') {
          <!-- Check is split between 2 ifs to suppress this menu item if user should not be accessing chat -->
          @if (showChat) {
            <a tabindex="0"
               id="td-wb-open-live-chat"
               role="button"
               class="td-wb-nav__primary__content-link td-wb-flyout-menu__item"
               (click)="openChat()"
               (keydown.enter)="openChat()">
              <span [innerHtml]="link.text"></span>
            </a>
          }
        } @else if (link.type === 'TEXT') {
          <div
            class="td-wb-nav__primary__content-text"
            [innerHtml]="link.text">
          </div>
        } @else if (link.type === 'LINK') {
          <a class="td-wb-nav__primary__content-link td-wb-flyout-menu__item"
             [href]="link.href"
             [target]="link.target === undefined ? '_self' : link.target"
             [innerHtml]="link.text">
          </a>
        } @else if (link.type === 'CONTACT_NUMBER') {
          <div
            class="td-wb-nav__primary__content-callus">
            <a role="button"
               [href]="link.href"
               class="td-wb-nav__primary__content-callus--link td-wb-flyout-menu__item">
              <span [innerHtml]="link.title"></span>
              <span [innerHtml]="link.text"></span>
            </a>
          </div>
        } @else if (!!link.external) {
          <div>
            <a role="button"
               class="td-wb-flyout-menu__item"
               [href]="link.href"
               [attr.target]="link.target">
              <span [innerHtml]="link.text"></span>
              <td-wb-icon iconId="new-page"
                          [inline]="true"/>
            </a>
          </div>
        } @else if (!link.external && link.type === undefined && link.href) {
          <a role="button"
             class="td-wb-flyout-menu__item"
             [attr.target]="link.target"
             [href]="link.href"
             [innerHtml]="link.text">
          </a>
        }
      }
    </div>
  </div>
</ng-template>
